/**
 * PeriodoQuickAddBar — barra "Aggiungi qui" contestuale per la PaginaPeriodo.
 *
 * Pre-compila la data del giorno (per MIT) o la settimana ISO (per Azione)
 * in base alla granularità della pagina corrente:
 *   - giorno    → MIT con dataIso=label, Azione con settimana derivata
 *   - settimana → MIT senza data (default oggi), Azione con settimana=label
 *   - mese/quarter/anno → MIT default oggi, Azione default settimana corrente
 *
 * Espone l'evento `qp:quick-add-open` su window con `detail` precompilato:
 * il componente `QuickAdd` globale lo intercetta e apre il modale prepopulato.
 */
import { weekFromIsoDate } from '../../lib/weekFromIsoDate';

export default function PeriodoQuickAddBar({ gran, label }) {
  const openQuickAdd = (kind) => {
    const detail = { kind };
    if (kind === 'mit') {
      if (gran === 'giorno') detail.dataIso = label;
    } else if (kind === 'azione') {
      if (gran === 'settimana') {
        detail.settimana = label;
      } else if (gran === 'giorno') {
        const w = weekFromIsoDate(label);
        if (w) detail.settimana = w;
      }
    }
    window.dispatchEvent(new CustomEvent('qp:quick-add-open', { detail }));
  };

  return (
    <div className="my-4 flex flex-wrap items-center gap-2" data-testid={`periodo-quickadd-${gran}`}>
      <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-mute mr-2">
        Aggiungi qui →
      </span>
      <button
        type="button"
        onClick={() => openQuickAdd('mit')}
        className="font-mono text-[10px] uppercase tracking-[0.18em] px-2.5 py-1.5 border border-line text-soft hover:border-ink hover:text-ink transition-colors inline-flex items-center gap-1.5"
        data-testid="periodo-quickadd-mit"
        title={gran === 'giorno' ? `Nuova MIT · ${label}` : 'Nuova MIT'}
      >
        <span className="text-base leading-none">+</span>
        MIT
      </button>
      <button
        type="button"
        onClick={() => openQuickAdd('azione')}
        className="font-mono text-[10px] uppercase tracking-[0.18em] px-2.5 py-1.5 border border-line text-soft hover:border-ink hover:text-ink transition-colors inline-flex items-center gap-1.5"
        data-testid="periodo-quickadd-azione"
        title={gran === 'settimana' ? `Nuova azione · ${label}` : 'Nuova azione'}
      >
        <span className="text-base leading-none">+</span>
        Azione
      </button>
    </div>
  );
}
